import { useRef } from 'react';
import { useTranslation } from 'next-i18next';
import styled from 'styled-components';
import type { Swiper as SwiperType } from 'swiper';
import { SwiperSlide } from 'swiper/react';
import { ImagePartial } from '@storefront/lib-global/partials/image';
import { colours } from '@storefront/lib-global/stylings';
import { useOccasionAndDenominationContext } from '../../context/occasionAndDenominationContext';
import CardSelector, { selectedCardStyle } from './CardSelector/CardSelector';

const S = {
  OccasionSelectorImage: styled.button<{ $isSelected: boolean }>`
    border: ${({ $isSelected }) => ($isSelected ? `1px solid ${colours.BLACK}` : 'none')};
    cursor: pointer;
    height: 100%;
    padding: 1px;
    width: 100%;

    ${({ $isSelected }) => ($isSelected ? selectedCardStyle : null)}

    &:hover,
    &:focus {
      border: 1px solid ${colours.BLACK};
      padding: 0;
    }
  `,
};

export function GiftCardOccasionSelector() {
  const { t } = useTranslation(['lib-products-common']);
  const { uniqueOccasions, selectedOccasionVariant, handleChangeOccasion, isSingleOccasion } =
    useOccasionAndDenominationContext();
  const swiperRef = useRef<SwiperType>();

  if (isSingleOccasion) return null;

  return (
    <CardSelector headerText={t('pdp.giftcard.select.card')} swiperRef={swiperRef}>
      {uniqueOccasions.map((variant, index) => (
        <SwiperSlide key={`${variant.occasion}-${index}`}>
          <S.OccasionSelectorImage
            onClick={() => handleChangeOccasion(variant)}
            type="button"
            $isSelected={`${variant.occasion}-${index}` === `${selectedOccasionVariant?.occasion}-${index}`}
            aria-label={variant?.occasion ?? ''}
            className="colour-selector-slide"
            data-testid="occasionSelector"
          >
            <ImagePartial src={variant.imageUrls?.[0] || ''} height={75} width={75} altText="" />
          </S.OccasionSelectorImage>
        </SwiperSlide>
      ))}
    </CardSelector>
  );
}

export default GiftCardOccasionSelector;
